import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { IMAGES } from "@/data/content";

const updateMeta = (selector, value) => {
  document.querySelector(selector)?.setAttribute("content", value);
};

export const Seo = () => {
  const { lang, t } = useLang();
  const { pathname } = useLocation();
  const projectId = pathname.startsWith("/project/") ? pathname.split("/").pop() : null;
  const project = IMAGES.portfolio.find((item) => item.id === projectId);
  const projectContent = project ? t.projects[project.id] : null;
  const title = project ? `${project.client} — InovoDesign` : t.seo.title;
  const description = projectContent ? projectContent.intro : t.seo.description;
  const image = project ? project.src : IMAGES.heroCar;
  const siteUrl = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    const pageUrl = `${siteUrl}${pathname}`;
    document.title = title;
    document.documentElement.lang = lang;
    document.querySelector('link[rel="canonical"]')?.setAttribute("href", pageUrl);
    updateMeta('meta[name="description"]', description);
    updateMeta('meta[property="og:title"]', title);
    updateMeta('meta[property="og:description"]', description);
    updateMeta('meta[property="og:url"]', pageUrl);
    updateMeta('meta[property="og:image"]', image);
    updateMeta('meta[property="og:image:alt"]', title);
    updateMeta('meta[name="twitter:title"]', title);
    updateMeta('meta[name="twitter:description"]', description);
    updateMeta('meta[name="twitter:image"]', image);
    updateMeta('meta[name="twitter:image:alt"]', title);
  }, [description, image, lang, pathname, siteUrl, title]);

  return null;
};